window.tipsFn=function(url,ev){
    ev = ev || window.event;
    var img=new Image();
    img.src=url;
    img.onload=function(){
        var w=img.width;
        var h=img.height;
        $(".tipsImg").attr("src",url).css({"top":parseInt(GetObjPos(ev)['y'])-(h/2)+"px","left":parseInt(GetObjPos(ev)['x'])+100+"px"}).show();
    }
}

window.tipsEnd=function (){
    $(".tipsImg").hide();
};
window.CPos=function (x, y)
{
    this.x = x;
    this.y = y;
};
window.GetObjPos=function (ATarget)
{
    var target = ATarget;
    var pos = new CPos(target.offsetLeft, target.offsetTop);
    var target = target.offsetParent;
    while (target)
    {
        pos.x += target.offsetLeft;
        pos.y += target.offsetTop;
        target = target.offsetParent
    }
    return pos;
};